import { FC, useEffect } from 'react';

const BASE_APP_DOC_TITLE = 'Workflows | Formstack';
const PAGE_TITLE_SEPARATOR = ' - ';

const setDocTitle = (title: string) =>
  (window.document.title = title
    ? `${title}${PAGE_TITLE_SEPARATOR}${BASE_APP_DOC_TITLE}`
    : BASE_APP_DOC_TITLE);

// IMPORTANT: Immediately set the doc title to a default.
setDocTitle('');

type DocTitleInstance = {
  title: string;
};

let DOC_TITLE_QUEUE: DocTitleInstance[] = [];

export type DocTitleProps = {
  children: string;
};

export const DocTitle: FC<DocTitleProps> = ({ children = '' }) => {
  useEffect(() => {
    const docTitleInstance: DocTitleInstance = {
      title: children,
    };
    DOC_TITLE_QUEUE = [...DOC_TITLE_QUEUE, docTitleInstance];

    setDocTitle(children);

    return () => {
      DOC_TITLE_QUEUE = DOC_TITLE_QUEUE.filter((instance) => instance !== docTitleInstance);

      const nextTitle = DOC_TITLE_QUEUE[DOC_TITLE_QUEUE.length - 1];

      if (nextTitle) {
        setDocTitle(nextTitle.title);
      } else {
        setDocTitle('');
      }
    };
  }, [children]);

  return null;
};
